import React, { useState, useContext } from 'react'
import axios from 'axios'
import { LinearProgress, Box } from '@mui/material';
import { DataGridPremium, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport, GridToolbarQuickFilter } from '@mui/x-data-grid-premium';
import { apiRoute } from '../../../App';
import UserContext from '../../../context/UserContext';

const DisbursementViewTable = ({ disburseDates, setDisburseDates, loadingDates, setLoadingDates, getDisburseReconDates, from, setFrom, setOpenModal, retrievedData, setRetrievedData, loading, setLoading, interestApplied, setInterestApplied }) => {
    const [selectedDate, setSelectedDate] = useState(false);
    const formattedDefaultDate = new Date().toISOString().split('T')[0];
    const [checkDate, setCheckDate] = useState(formattedDefaultDate);
    const [checkNumber, setCheckNumber] = useState(0);

    const { entityId } = useContext(UserContext)


    const previousDisbursedColumns = [
        {
            field: "Date",
            headerName: "Date",
            flex: 1
        },
        {
            field: "EnteredBy",
            headerName: "Disbursed By",
            align: 'center',
            headerAlign: 'center',
            flex: 1
        },
        {
            field: "TotalDisbursed",
            headerName: "Total Disbursed",
            flex: 1,
            align: 'right',
            headerAlign: 'right',
            renderCell: (params) => {
                return (<strong>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(params.value)}</strong>)
            }
        }
    ];



    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
                <div style={{ flex: 1 }} />
                <GridToolbarQuickFilter />
            </GridToolbarContainer>
        )
    }

    const retrieveDisburseDetails = async (value) => {
        setLoading(true);
        setSelectedDate(value);
        await axios.get(`${apiRoute}/api/DisburseDtl/retrieveDisburseDetails/${value}`)
            .then(({ data }) => {
                data.forEach((d) => {
                    const disburseDate = new Date(d.disburseDate);
                    const formattedDate = (disburseDate.getMonth() + 1).toString().padStart(2, '0') + '/' + disburseDate.getDate().toString().padStart(2, '0') + '/' + disburseDate.getFullYear();
                    d.id = crypto.randomUUID();
                    d.totalDisburseAmount = (d.totalDisburseAmount).toFixed(2);
                    d.grandTotal = (parseFloat(d.totalDisburseAmount) + d.bankInterest + (d.allocations + d.deductions)).toFixed(2);
                    d.entityId = entityId;
                    d.bankInterest = d.bankInterest.toFixed(2)
                    d.disbursedDate = formattedDate;
                    d.allocatedAmount = (d.allocations + d.deductions).toFixed(2);
                    if (d.bankInterest > 0 && !interestApplied) {
                        setInterestApplied(true);
                    }
                });
                setRetrievedData(data);
                setLoading(false);
            })
            .then((data) => { setFrom('retrieved'); setOpenModal(true); setLoading(false); })
            .catch(e => { console.error(e); setLoading(false); });
    };

    return (
        <Box sx={{ height: 'auto', maxHeight: '55vh' }}>
            <DataGridPremium
                rows={disburseDates}
                columns={previousDisbursedColumns.map((column, index) => ({
                    ...column,
                    headerClassName: index === 0 ? 'first-column-header' : index === previousDisbursedColumns.length - 1 ? 'last-column-header' : '',
                    cellClassName: index === 0 ? 'first-column-cell' : index === previousDisbursedColumns.length - 1 ? 'last-column-cell' : '',

                }))}
                loading={loadingDates | loading}
                disableMultipleRowSelection
                onRowClick={(p) => retrieveDisburseDetails(p.row.DisburseId)}
                initialState={{
                    sorting: { sortModel: [{ field: 'date', sort: 'desc' }] },
                    pagination: { paginationModel: { pageSize: 25 } },
                    density: "standard"
                }}
                slots={{
                    toolbar: CustomToolbar,
                    loadingOverlay: LinearProgress,
                }}
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                        printOptions: { disableToolbarButton: true },
                    },
                }}
                localeText={{
                    noRowsLabel:
                        'No Disbursements Found',
                }}
                rowHeight={60}
                sx={{
                    ".MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel": {
                        marginTop: "1em",
                        marginBottom: "1em"
                    },
                    maxHeight: '55vh',
                    '.first-column-header': {
                        paddingLeft: '3em', // Adjust the padding value as needed
                    },
                    '.first-column-cell': {
                        paddingLeft: '3em', // Adjust the padding value as needed
                    },'.last-column-header': {
                        paddingRight: '3em', // Adjust the padding value as needed
                    },
                    '.last-column-cell': {
                        paddingRight: '3em', // Adjust the padding value as needed
                    },
                    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                        outline: "none !important",
                    }, "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus": {
                        outline: "none !important",
                    },
                }}
            />
        </Box>
    )
}

export default DisbursementViewTable;